import { PRICE_DECIMAL_PLACES } from '@features/invoices/constants/priceDecimalPlaces'

import { NumberValue } from '../../../../../../../../../utils'

export const getUnitPrice = (totalPrice: number | string, quantity: number) =>
  new NumberValue(totalPrice).divide(quantity).getRounded(PRICE_DECIMAL_PLACES)
